export const Spinner = ({ size = "sm" }: { size?: "md" | "lg" | "sm" }) => {
  const sizes = {
    sm: "h-6 w-6",
    md: "h-12 w-12",
    lg: "h-20 w-20",
  };

  return (
    <div className="flex flex-col">
      <div
        className={`${sizes[size]} animate-spin rounded-full
				border-4 border-solid border-blue-700 border-t-transparent`}
      ></div>
    </div>
  );
};
